import { isPlanningWriteBusy } from "./planningMutationActivity.js";

export const PRODUCT_UPDATE_POLL_MS = 15000;
export const PRODUCT_UPDATE_GATE_MS = 2000;
export const publicationDismissalId = id => `pu:${id}`;
export const publicationAnnouncementId = publication => publication?.announcement_id || publication?.id;

export function canOpenProductUpdateAnnouncement({ document: doc = globalThis.document, optimizationStatus, dialog, planningBusy = isPlanningWriteBusy() } = {}) {
  if (!doc || doc.visibilityState === "hidden" || planningBusy) return false;
  if (["starting", "queued", "running", "cancelling"].includes(optimizationStatus)) return false;
  const active = doc.activeElement;
  if (active?.matches?.("input, textarea, select") || active?.isContentEditable
    || active?.closest?.('[contenteditable]:not([contenteditable="false"])')) return false;
  return ![...doc.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => element !== dialog);
}

export function startProductUpdatePolling({ fetchAnnouncement, onPublication, onError = () => {}, document: doc = document, window: win = window,
  setInterval: repeat = globalThis.setInterval, clearInterval: cancel = globalThis.clearInterval }) {
  let stopped = false;
  let inFlight = false;
  const controller = new AbortController();
  async function poll() {
    if (stopped || inFlight || doc.visibilityState === "hidden") return;
    inFlight = true;
    try {
      const publication = await fetchAnnouncement(controller.signal);
      if (!stopped) onPublication(publication);
    } catch (error) {
      if (!stopped && error.name !== "AbortError") onError(error);
    } finally { inFlight = false; }
  }
  const interval = repeat(poll, PRODUCT_UPDATE_POLL_MS);
  win.addEventListener("focus", poll);
  doc.addEventListener("visibilitychange", poll);
  void poll();
  return () => {
    stopped = true;
    controller.abort();
    cancel(interval);
    win.removeEventListener("focus", poll);
    doc.removeEventListener("visibilitychange", poll);
  };
}
